import { Icon, IconArrowDown } from "@flixbus/honeycomb-icons-react";
import { DropdownItem, Panel, PanelContent, PanelHeader, Skeleton, Tag } from "@flixbus/honeycomb-react";
import * as React from "react";
import { FormattedMessage } from "react-intl";
import { SortDirection, SortField } from "../../../../shared/types/schema";
import useRideSort, { RideSort, rideSortVar } from "../../../../state/useRideSort/useRideSort";
import getSortButtonLabel from "../../helpers/getSortButtonLabel/getSortButtonLabel";
import * as css from "./RideSortButton.scss";

type Props = { loading: boolean };

const RideSortButton: React.FC<Props> = ({ loading }) => {
  const [rideSort, setRideSort] = useRideSort(rideSortVar);
  const [panelActive, setPanelActive] = React.useState(false);

  const onSelectOption = (sort: RideSort) => {
    setRideSort({ field: sort.field, direction: sort.direction });
    setPanelActive(false);
  };

  const sortOptions = [
    { field: SortField.Departure, direction: SortDirection.Asc, label: "ride.sort.option.dateAsc" },
    { field: SortField.Departure, direction: SortDirection.Desc, label: "ride.sort.option.dateDsc" },
    { field: SortField.NumberOfPax, direction: SortDirection.Desc, label: "ride.sort.option.numberOfPassengersDsc" },
    { field: SortField.NumberOfPax, direction: SortDirection.Asc, label: "ride.sort.option.numberOfPassengersAsc" },
  ];

  if (loading) {
    return (
      <div className={css.skeletonWrapper}>
        <Skeleton Elem="div" height="md" flushBottom round extraClasses={css.skeleton} />
      </div>
    );
  }

  return (
    <>
      <Tag display="outlined" onClick={() => setPanelActive(true)} extraClasses={css.tag}>
        {getSortButtonLabel(rideSort)}
        <Icon InlineIcon={IconArrowDown} />
      </Tag>

      <Panel
        id="sort-options"
        active={panelActive}
        position="bottom"
        hasOverlay
        onOverlayClick={() => setPanelActive(false)}
        extraClasses={css.panel}
      >
        <PanelHeader
          closeButtonProps={{ label: "Close", onClick: () => setPanelActive(false) }}
          extraClasses={css.panelHeader}
        >
          <b>
            <FormattedMessage id="ride.sort.header" />
          </b>
        </PanelHeader>
        <PanelContent>
          {sortOptions.map(({ field, direction, label }) => (
            <DropdownItem
              key={label}
              active={rideSort.field === field && rideSort.direction === direction}
              onClick={() => onSelectOption({ field, direction })}
              extraClasses={css.dropdownItem}
            >
              <FormattedMessage id={label} />
            </DropdownItem>
          ))}
        </PanelContent>
      </Panel>
    </>
  );
};

export default RideSortButton;
